<template>
  <v-carousel
    v-model="model"
    :height="height"
    hide-delimiter-background
    hide-delimiters
  >
    <v-carousel-item v-for="(image, index) in productImages" :key="index">
      <v-img :src="image" tile />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'ProductImageSlider',
  props: {
    productImages: {
      type: Array,
      required: true
    },
    height: {
      type: String,
      default: '160'
    }
  },
  data () {
    return {
      model: 0
    }
  }
}
</script>
